export const FORGOT_PASSWORD_TAG_NAME = 'forgot-password';
